import { render, staticRenderFns } from "./dialog-look-contract-file.vue?vue&type=template&id=6c8c9a3a&scoped=true&"
import script from "./dialog-look-contract-file.vue?vue&type=script&lang=js&"
export * from "./dialog-look-contract-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8c9a3a",
  null
  
)

export default component.exports